'use client';
import React, { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import PageLoaderContext from '@/app/_contexts/page-loader-context/PageLoaderContext';
// import { SessionProvider } from "next-auth/react";
// import { Session } from "next-auth";

import styles from './pageLoader.module.scss';
// import { useRouter } from "next/navigation";
type Props = {
  children: React.ReactNode;
  // session: Session | null;
};

const PageLoaderProvider = ({ children }: Props) => {
  const [isPageLoading, setIsPageLoading] = useState<boolean>(false);
  const [delayedAnimation, setDelayedAnimation] = useState<boolean>(false);
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout | null>(null);

  // const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [timeoutId]);

  useEffect(() => {
    // console.log("isPageLoading from provider: ", isPageLoading );

    if (!isPageLoading) {
      setDelayedAnimation(false);
    } else {
      setDelayedAnimation(true);
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
        setDelayedAnimation(false);
      }
    };
  }, [isPageLoading]);

  const updateIsLoadingHandler = (
    e?:
      | React.MouseEvent<HTMLButtonElement, MouseEvent>
      | React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    // console.log("UpdateIsLoading is called from provider");

    e?.preventDefault();
    setIsPageLoading((prev) => !prev);
    const id = setTimeout(() => {
      setDelayedAnimation(true);
    }, 50);
    setTimeoutId(id);
  };

  const updateIsLoadingTrueHandler = (
    e?: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    // console.log("UpdateIsLoading is called from provider");

    e?.preventDefault();
    setIsPageLoading(true);
    const id = setTimeout(() => {
      setDelayedAnimation(true);
    }, 50);
    setTimeoutId(id);
  };
  return (
    <PageLoaderContext.Provider
      value={{
        isPageLoading,
        updateIsLoadingHandler,
        setIsPageLoading,
        updateIsLoadingTrueHandler
      }}
    >
      <>
        {isPageLoading && (
          <div className={styles.pageLoaderWrapper}>
            <div
              className={`${styles.loaderWrapper} ${
                delayedAnimation ? styles.active : ''
              }`}
            >
              <div className={styles.loader}>
                <span className={styles.inner_1}></span>
                <span className={styles.inner_2}></span>
                <span className={styles.inner_3}></span>
              </div>
            </div>
          </div>
        )}
        {children}
      </>
    </PageLoaderContext.Provider>
  );
};

export default PageLoaderProvider;
